import React from "react";
import Nav from "../common/Nav";
import Footer from "../common/Footer";
import SideService from "../common/Side-Service";
import S1 from "../img/services/4.png"

const FullPacking = () => {
    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>Full Packing</h2>
            </section>
            <section className="service-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <SideService />
                        </div>
                        <div className="col-lg-8">
                            <div className="service-contnt">
                                <img src={S1} />
                                <h4>Full Packing</h4>
                                <p>When it comes to a stress-free move, having a professional full-packing service is essential. At Golden State Movers, we take the hassle out of moving by offering comprehensive packing solutions tailored to your needs. Our team of skilled packers uses high-quality packing materials to carefully and efficiently secure your belongings, ensuring their safety during transit.</p>
                                <p>From delicate items like dishes, mirrors, and electronics to bulky furniture and wardrobe essentials, we handle it all with precision. We provide specialty boxes for fragile items and wardrobe boxes for your clothing, along with eco-friendly packing options to minimize waste. Our full-packing service ensures every item is expertly packed, labeled, and organized, so you can focus on settling into your new space.</p>
                                <p>With Golden State Movers, your valuables are in trusted hands. Let us simplify your move with our reliable, professional-grade packing services designed for your complete peace of mind.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default FullPacking;